export const clearFormat = (value: string, onlyCPF?: boolean) => {
  if (!value) {
    return '';
  }
  if (onlyCPF) {
    return value
      .trim()
      .replace(/[^0-9]/g, '')
      .slice(0, 11);
  }
  return value.trim().replace(/[^0-9]/g, '');
};

export const getUnmaskedValue = (value: any) =>
  String(value).replace(/\D/g, '');

export const formatCNPJ = (input: any) => {
  const value = String(input) // Transforma em String
    .replace(/\D/g, '') // Retira o que não é número
    .slice(0, 14)
    .replace(/(\d{2})(\d{1,3})/, '$1.$2')
    .replace(/(\d{3})(\d{1,3})/, '$1.$2')
    .replace(/(\d{3})(\d{1,4})/, '$1/$2')
    .replace(/(\d{4})(\d{1,2})/, '$1-$2');

  return value;
};

export const formatCPF = (input: any) => {
  const value = String(input) // Transforma em String
    .replace(/\D/g, '') // Retira o que não é número
    .slice(0, 11) // Limita o tamanho
    .replace(/(\d{3})(\d{1,3})/, '$1.$2') // Coloca o primeiro ponto
    .replace(/(\d{3})(\d{1,3})/, '$1.$2') // Coloca o segundo ponto
    .replace(/(\d{3}\.{1}\d{3}\.{1}\d{3})(\d{1,2})/, '$1-$2'); // Coloca o traço
  return value;
};

export const formatCPFCNPJ = (input: any) => {
  let value = String(input).replace(/\D/g, '').slice(0, 14);
  if (value.length > 11) return formatCNPJ(value);
  return formatCPF(value);
};

export const formatCPFOrCNPJ = (value: string, onlyCPF?: boolean) => {
  return onlyCPF ? formatCPF(value) : formatCPFCNPJ(value);
};

const cpfsInvalidos = [
  '00000000000',
  '11111111111',
  '22222222222',
  '33333333333',
  '44444444444',
  '55555555555',
  '66666666666',
  '77777777777',
  '88888888888',
  '99999999999',
];

export const validaCPF = (cpf: any) => {
  cpf = getUnmaskedValue(cpf);
  if (cpf.length < 11 || cpfsInvalidos.indexOf(cpf) > -1) return false;
  // PRIMEIRO DIGITO
  let primeiraSoma = 0;
  for (let i = 0; i < 9; i++) {
    primeiraSoma += (10 - i) * parseInt(cpf[i]);
  }
  let primeiroResto = (primeiraSoma * 10) % 11;
  if (primeiroResto >= 10) primeiroResto = 0;
  if (primeiroResto !== parseInt(cpf[9])) return false;
  // SEGUNDO DIGITO
  let segundaSoma = 0;
  for (let i = 0; i < 10; i++) {
    segundaSoma += (11 - i) * parseInt(cpf[i]);
  }
  let segundoResto = (segundaSoma * 10) % 11;
  if (segundoResto >= 10) segundoResto = 0;
  if (segundoResto !== parseInt(cpf[10])) return false;
  return true;
};

export function validarCPF(cpf: string) {
  return validaCPF(cpf);
}
